import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import store from '../store'

const request = axios.create({
  baseURL: '/api',
  timeout: 30000,
})

// 请求拦截：自动带 token；平台超管切换门店时统一附加 shopId（与中台租户上下文对齐）
request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) config.headers['Authorization'] = `Bearer ${token}`
  const u = store.state.userInfo || {}
  if (u.role === 'super_admin' && u.activeShopId) {
    config.params = { ...(config.params || {}), shopId: u.activeShopId }
  }
  return config
})

// 响应拦截：统一错误处理
request.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token')
      router.push('/login')
      Message.error('登录已过期，请重新登录')
    } else {
      Message.error(err.response?.data?.message || '网络错误，请稍后重试')
    }
    return Promise.reject(err)
  }
)

export default request
